"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMD5 = void 0;
const assertString_1 = require("./util/assertString");
const md5 = /^[a-f0-9]{32}$/;
function isMD5(str) {
    (0, assertString_1.assertString)(str);
    return md5.test(str);
}
exports.isMD5 = isMD5;
